'use client';
import React, { useEffect, useRef } from "react";
import Subheading from "../Subheading/Subheading";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import type { Swiper as SwiperType } from "swiper/types";
// import "swiper/swiper-bundle.css";
import './TestimonialCard.css';
import { LanguageType, LanguageDirection } from '@/lib/types';
import { useIsLg, useIsTb } from '@/contexts/BreakpointContext';

const LANGUAGE_TO_DIRECTION: Record<LanguageType, LanguageDirection> = {
	english: "ltr",
	arabic: "rtl"
};

interface TestimonialContent {
	testimonialText: string;
	testimonialAuthor: string;
	displayOrder?: number;
}

interface TestimonialCardProps {
	testimonials: TestimonialContent[]
	addTopPadding: boolean
	language: LanguageType
}


const TestimonialCard: React.FC<TestimonialCardProps> = ({
	testimonials,
	addTopPadding = false,
	language = "english"
}) => {
	const isTb = useIsTb();
	const isLg = useIsLg();
	const swiperRef = useRef<SwiperType>(null);

	useEffect(() => {
		if (swiperRef.current) {
			swiperRef.current.snapGrid = [...swiperRef.current.slidesGrid];
		}
		return () => {
			if (swiperRef.current) {
			}
		};
	}, []);

	return (
		<section
			style={{
				direction: LANGUAGE_TO_DIRECTION[language],
				paddingTop: addTopPadding ?
					isLg ?
						'3.5rem'
						:
						(isTb ? '2.5rem' : '0rem')
					:
					'0'
			}}
			// pt-[1rem]
			// padding-main-t-desktop
			className="
			w-full
			px-[1.25rem]
			padding-main-x-desktop
			flex items-center justify-center
			">
			<div className="w-full container-small">
				<div className="
					flex flex-col items-center justify-center
					text-center
					overflow-hidden
					gap-[2rem]
					lg:gap-[2.5rem]
					w-full
					">
					<img
						src="/Support-Lockup-Registration-None.svg"
						alt="Support lockup with no registration"
						className="h-[44px] tb:h-[64px]"
					/>
					<Swiper
						style={{
							width: '100%',
							overflow: 'visible'  // Allow overflow for expanded cards
						}}
						modules={[Pagination, Autoplay]}
						pagination={{
							clickable: true,
							el: '.swiper-custom-pagination',
							bulletClass: 'swiper-pagination-bullet',
							bulletActiveClass: 'swiper-pagination-bullet-active',
						}}
						loop={testimonials.length > 1}
						spaceBetween={isLg ? 16 : 12}
						slidesPerView="auto"
						autoplay={{
							delay: 5000,
							disableOnInteraction: true,
						}}
						onBeforeInit={(swiper) => {
							swiperRef.current = swiper;
						}}
						centeredSlidesBounds={isLg ? false : true}
						centeredSlides={isLg ? false : true}
						observer={true}
						observeSlideChildren={true}
						resizeObserver={true}
						className="!overflow-visible testimonial-swiper pb-8"
					>

						<div className="w-full overflow-hidden " >
							<div className="w-full">
								<div className="flex w-full">
									{testimonials.map((testimonial) => (

										<SwiperSlide key={testimonial.testimonialText}
											style={{
												height: 'auto',
												width: '100%',
											}}
											className="cursor-grab"
										>
											<div
												className="
												flex flex-col items-center justify-start
												text-center
												overflow-hidden
												gap-[2rem]
												lg:gap-[2.5rem]
												w-full
												h-full
												">
												<div
													className="w-full"
													style={{ minWidth: '100%' }}
												>

													<p className='
													  text-text-primary text-center
														text-36-to-20--neue-june
														'>
														"{testimonial.testimonialText}"
													</p>

												</div>
												<div style={{ direction: "ltr" }}>
													<Subheading size={isLg ? 24 : 16} subheading={testimonial.testimonialAuthor} alignment="center" language={language} />
												</div>
											</div>
										</SwiperSlide>

									))}
								</div>

							</div>

						</div>

						{testimonials.length > 1 && <div className="swiper-custom-pagination  mt-[2rem] lg:mt-[2.5rem] w-full flex justify-center gap-[0.625rem]" />}
					</Swiper>
				</div>
			</div>
		</section >
	);
}

export default TestimonialCard;
